import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Manages navigation triggered from the search dialog.
 * Tracks `isNavigating` so the dialog can suppress its close animation —
 * preventing the fading dialog from revealing a partially-loaded page.
 */
export const useSearchNavigation = (setOpen: (open: boolean) => void) => {
  const navigate = useNavigate();
  const [isNavigating, setIsNavigating] = useState(false);

  const navigateTo = useCallback(
    (path: string) => {
      setIsNavigating(true);
      navigate(path);
      setOpen(false);
    },
    [navigate, setOpen],
  );

  const reset = useCallback(() => setIsNavigating(false), []);

  return { navigateTo, isNavigating, reset } as const;
};
